import {getElements} from "./utils/getElement";

const initLicense = () => {

    if (typeof ClipboardJS === 'undefined') {
        return;
    }

    const licenseContainers = document.querySelectorAll('.c-license');

    licenseContainers.forEach(container => {

        const licenseCopyBtn = container.querySelector('.js-license-copy-btn');

        if (licenseCopyBtn) {
            new ClipboardJS(licenseCopyBtn);
        }
    });


    const licenseInputs = getElements('.js-license-input')

    if (licenseInputs) {
        licenseInputs.map(licenseInput => {
            licenseInput.addEventListener('focus', function () {
                licenseInput.select();
            });
        })
    }
}

export {initLicense}
